import React from 'react'
import AttendanceSubNav from '../components/AttendanceSubNav'
import BiometricRecordsDateNav from './components/BiometricRecordsDateNav'
import BiometricRecordsMetrics from './components/BiometricRecordsMetrics'
import BiometricRecordsTable from './components/BiometricRecordsTable'
import SharedFilters from '../../../components/SharedFilters'
import PredefinedReportsDrawer from '../../../components/PredefinedReportsDrawer'
import useBiometricRecords from './hooks/useBiometricRecords'

export default function BiometricRecordsScreen() {
  const { state, actions } = useBiometricRecords()

  const toolsConfig = [
    { key: 'print-report', label: 'Print Report', icon: 'print' },
    { key: 'export-excel', label: 'Export Swipes to Excel', icon: 'table_view' },
    { key: 'send-sms', label: 'Send Swipe Log SMS', icon: 'sms' },
  ]

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Top Canopy: Header & SubNav ── */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">Biometric &amp; Swipes</p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Biometric Swipe Records
          </h1>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Raw machine swipe logs, RFID card scans, and terminal reconciliation registers.
          </p>
        </div>

        {/* ── Date Stepper Toolbar ── */}
        <BiometricRecordsDateNav
          date={state.date}
          onDateChange={actions.setDate}
          onPrevDate={actions.handlePrevDate}
          onNextDate={actions.handleNextDate}
          onToday={actions.handleToday}
          onYesterday={actions.handleYesterday}
        />
      </section>


      {/* ── KPI Metrics Bar ── */}
      {/* <BiometricRecordsMetrics metrics={state.metrics} loading={state.loading} /> */}

      {/* ── Shared Filter Accordion & Tools ── */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        companyFilter={state.companyFilter}
        branchFilter={state.branchFilter}
        courseFilter={state.courseFilter}
        schoolFilter={state.schoolFilter}
        academicYearFilter={state.academicYearFilter}
        batchFilter={state.batchFilter}
        subjectFilter={state.subjectFilter}
        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        setCompanyFilter={actions.setCompanyFilter}
        setBranchFilter={actions.setBranchFilter}
        setCourseFilter={actions.setCourseFilter}
        setSchoolFilter={actions.setSchoolFilter}
        setAcademicYearFilter={actions.setAcademicYearFilter}
        setBatchFilter={actions.setBatchFilter}
        setSubjectFilter={actions.setSubjectFilter}
        onReset={actions.handleResetFilters}
        onSearch={() => { }}
        searchFieldOptions={state.options.searchFields}
        companyOptions={state.options.companies}
        branchOptions={state.options.branches}
        courseOptions={state.options.courses}
        schoolOptions={state.options.schools}
        batchOptions={state.options.batches}
        subjectOptions={state.options.subjects}
        academicYearOptions={state.options.academicYears}
        visibleAccordionFilters={[
          'company',
          'branch',
          'course',
          'school',
          'academicYear',
          'batch',
          'subject',
        ]}
        tools={toolsConfig}
        onToolSelect={(key) => {
          if (key === 'print-report') {
            actions.setIsReportsOpen(true)
          } else if (key === 'export-excel') {
            actions.handleExportExcel()
          } else if (key === 'send-sms') {
            actions.handleSendSMS()
          }
        }}
      />

      {/* ── Biometric Swipes Data Table ── */}
      <BiometricRecordsTable
        records={state.records}
        loading={state.loading}
        sortBy={state.sortBy}
        sortOrder={state.sortOrder}
        onSort={actions.handleSort}
      />

      {/* ── Predefined Reports Drawer ── */}
      <PredefinedReportsDrawer
        isOpen={state.isReportsOpen}
        onClose={() => actions.setIsReportsOpen(false)}
        title="Biometric Swipe Reports"
        module="attendance"
        submodule="biometric"
        moduleLabel="Biometric Swipes"
        filters={{
          date: state.date,
          academicYear: state.academicYear,
          courseId: state.courseId,
          batchId: state.batchId,
          branchId: state.branchId,
          schoolId: state.schoolId,
        }}
      />
    </div>
  )
}
